import './bluefiretotal4/style';
import FormStructure from './bluefiretotal4/form_structure';

export default FormStructure;